import { TableBody, TableHead, TableRow } from '@mui/material';
import type { NsnReport } from '@physna/core/domain/nsn-report/nsn-report';
import { StyledHeaderCell, StyledTable, StyledTableCell, StyledTableRow } from './NsnTable';

export const ManufacturersTable = ({ manufacturers }: Pick<NsnReport, 'manufacturers'>) => {
  return (
    <StyledTable size='small'>
      <TableHead>
        <TableRow>
          <StyledHeaderCell>Part Number</StyledHeaderCell>
          <StyledHeaderCell>Company</StyledHeaderCell>
          <StyledHeaderCell>CAGE Code</StyledHeaderCell>
          <StyledHeaderCell>CAGE Status</StyledHeaderCell>
          <StyledHeaderCell>CAGE Type</StyledHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {manufacturers.map((manufacturer, index) => (
          <StyledTableRow key={`manufacturer-${manufacturer.partNumber}-${index}`}>
            <StyledTableCell>{manufacturer.partNumber}</StyledTableCell>
            <StyledTableCell>{manufacturer.company}</StyledTableCell>
            <StyledTableCell>{manufacturer.cageCode}</StyledTableCell>
            <StyledTableCell>{manufacturer.cageStatus}</StyledTableCell>
            <StyledTableCell>{manufacturer.cageType}</StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
